import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "./stores"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const selectCurrentPlayer = (state: RootState) =>
  state.game.players.find((p) => p.id === state.game.currentPlayerId)

export const selectConnectedPlayer = (state: RootState) =>
  state.game.players.find((p) => p.id === state.network.uid)
